/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React from "react";
/**
 * @brief EHP Hilight 컴포넌트
 * @param -
 * @returns react components
 */
function HilightSpan(props) {
    const word = props.word;
    const keyword = props.keyword;
    const pos = word.toUpperCase().indexOf(keyword.toUpperCase());
    return (React.createElement(React.Fragment, null,
        (pos < 0) ? "" : word.substring(0, pos),
        React.createElement("span", { className: "highlight" }, (pos < 0) ? "" : word.substring(pos, pos + keyword.length)),
        (pos < 0) ? word : word.substring(pos + keyword.length)));
}
export default HilightSpan;
